import React, { CSSProperties, RefAttributes } from 'react';
import { Spinner } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

import {
  ButtonStylesProps as StylesProps,
  Button as ButtonStyled,
} from './ButtonStyles';

type Props = {
  id?: string;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  to?: string;
  loading?: boolean;
  style?: CSSProperties;
  height?: string;
} & Partial<StylesProps> &
  RefAttributes<HTMLButtonElement>;

export const Button: React.FC<Props> = React.forwardRef<
  HTMLButtonElement,
  Props
>(
  (
    {
      id,
      className,
      type = 'button',
      variant = 'primary',
      disabled = false,
      onClick,
      to,
      children,
      loading = false,
      ...rest
    },
    ref
  ) => {
    const history = useHistory();

    return (
      <ButtonStyled
        {...rest}
        id={id}
        ref={ref}
        className={className}
        type={type}
        variant={variant}
        disabled={disabled}
        onClick={to ? () => history.push(to) : onClick}
      >
        {loading && (
          <Spinner
            as='span'
            animation='border'
            size='sm'
            className='mr-2'
            role='status'
            aria-hidden='true'
          />
        )}
        {children}
      </ButtonStyled>
    );
  }
);
